import { fg } from '@atlassian/jira-feature-gating';

export function isReactCompilerForLabelsFieldEnabled() {
	if (fg('react_compiler_for_labels_field')) {
		return true;
	}
	return false;
}

export function isReactCompilerForBatch1Enabled() {
	if (fg('jiv_react_compiler_batch_1')) {
		return true;
	}
	return false;
}

export function isReactCompilerForIssueAttachmentsEnabled() {
	if (fg('jiv_react_compiler_for_issue_attachments')) {
		return true;
	}
	return false;
}

export function isReactCompilerForBatch2Enabled() {
	if (fg('jiv_react_compiler_batch_2')) {
		return true;
	}
	return false;
}
